import React from 'react';
import { IView } from 'interfaces/common';
import { IRoles } from 'interfaces/roles.interface';

const ViewRegister: IView = {
  key: 'viewRegister',
  title: 'registerView.title',
  view: React.lazy(() => import('./register')),
  path: '/rejestracja',
  roles: [IRoles.ADMINISTRATOR, IRoles.HR],
  navigation: true,
};

export default ViewRegister;
